// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__apBm1","buttons":"PendingPaymentAlert_buttons__1cAZT"};